module.exports = __webpack_public_path__ + "static/media/arrow-right.12792e7a.svg";